import { AxiosResponse } from 'axios';
import { useMutation } from 'react-query';

// configs
import { API } from 'configs/api';
// utils
import { getShortUrlFromUrl } from 'utils/url';
// types
import { UpdateQuoteItemBody } from './types';

const approveQuoteItemsMutation = async ({
  data,
}: {
  data?: UpdateQuoteItemBody;
}) => {
  const shortUrl = getShortUrlFromUrl();
  if (!shortUrl) {
    throw new Error('Invalid url');
  }

  const response: AxiosResponse = await API.patch(
    `/playback/${shortUrl}/approve`,
    data
  );

  return response.data;
};

export const useApproveQuoteItemsMutation = () => {
  return useMutation<AxiosResponse, Error, { data?: UpdateQuoteItemBody }>(
    approveQuoteItemsMutation
  );
};
